<style>
  .menu-item {
    color: var(--text-color) !important;
  }
  .menu-item:hover {
    color: #009dff !important;
  }
  .selected {
    color: #009dff !important;
  }
</style>
<template>
  <div>
    <div :class="isUrl('') ? 'mb-4' : 'mb-4'">
      <Link class="group flex items-center py-3" href="/">
        <icon name="dashboard" class="mr-2 w-4 h-4" :class="isUrl('') ? 'fill-white' : 'fill-gray-600 group-hover:fill-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}" />
        <div :class="isUrl('') ? 'menu-item font-bold selected' : 'text-gray-600 group-hover:text-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}">Escritorio</div>
      </Link>
    </div>

    <div v-if="role == 'admin'" :class="isUrl('overview') ? 'mb-4' : 'mb-4'">
      <Link class="group flex items-center py-3" href="/overview">
        <icon name="dashboard" class="mr-2 w-4 h-4" :class="isUrl('overview') ? 'fill-white' : 'fill-gray-600 group-hover:fill-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}" />
        <div :class="isUrl('overview') ? 'menu-item font-bold selected' : 'text-gray-600 group-hover:text-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}">Overview</div>
      </Link>
    </div>
    <div v-if="role == 'admin' || role == 'endline' || role == 'storer'" class="mb-4">
      <Link class="group flex items-center py-3" href="/products">
        <i :class="isUrl('products') ? 'fa fa-shopping-cart mr-2 text-white' : 'fa fa-shopping-cart mr-2 text-gray-600 group-hover:fill-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}" />
        <div :class="isUrl('products') ? 'menu-item font-bold selected' : 'text-gray-500 group-hover:text-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}">Productos</div>
      </Link>
    </div>
    <div class="mb-4" v-if="role == 'admin' || role == 'sales' || role == 'financial' || role == 'supersales'">
      <Link class="group flex items-center py-3" href="/clients">
        <i :class="isUrl('clients') ? 'fa fa-address-book mr-2 text-white' : 'fa fa-address-book mr-2 text-gray-600 group-hover:fill-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}" />
        <div :class="isUrl('clients') ? 'menu-item font-bold selected' : 'text-gray-500 group-hover:text-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}">Clientes</div>
      </Link>
    </div>
    <div class="mb-4" v-if="role == 'admin' || role == 'financial'">
      <Link class="group flex items-center py-3" href="/clients/payments">
        <i :class="isUrl('clients/payments') ? 'fa fa-address-book mr-2 text-white' : 'fa fa-address-book mr-2 text-gray-600 group-hover:fill-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}" />
        <div :class="isUrl('clients/payments') ? 'menu-item font-bold selected' : 'text-gray-500 group-hover:text-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}">Cobranzas</div>
      </Link>
    </div>
    <div class="mb-4" v-if="role == 'admin' || role == 'endline' || role == 'storer'">
      <Link class="group flex items-center py-3" href="/inventories">
        <i :class="isUrl('inventories') ? 'fa fa-th-large mr-2 text-white' : 'fa fa-th-large mr-2 text-gray-600 group-hover:fill-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}" />
        <div :class="isUrl('inventories') ? 'menu-item font-bold selected' : 'text-gray-500 group-hover:text-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}">Inventario</div>
      </Link>
    </div>
    <div class="mb-4" v-if="role == 'admin' || role == 'endline' || role == 'storer'">
      <Link class="group flex items-center py-3" href="/loads">
        <i :class="isUrl('loads') ? 'fa fa-th-large mr-2 text-white' : 'fa fa-th-large mr-2 text-gray-600 group-hover:fill-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}" />
        <div :class="isUrl('loads') ? 'menu-item font-bold selected' : 'text-gray-500 group-hover:text-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}">Lote de carga</div>
      </Link>
    </div>
    <div v-if="role == 'sales' || role == 'admin' || role == 'storer' || role == 'financial' || role == 'supersales' || role == 'client'" class="mb-4">
      <Link class="group flex items-center py-3" href="/orders">
        <i :class="isUrl('orders') ? 'fa fa-shopping-cart mr-2 text-white' : 'fa fa-shopping-cart mr-2 text-gray-600 group-hover:fill-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}" />
        <div :class="isUrl('orders') ? 'menu-item font-bold selected' : 'text-gray-500 group-hover:text-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}">{{role == 'client' || role == 'storer' ? 'Pedidos' : 'Ventas'}}</div>
      </Link>
    </div>
    <div v-if="role == 'admin' || role == 'supersales'" class="mb-4">
      <Link class="group flex items-center py-3" href="/vendors">
        <i :class="isUrl('vendors') ? 'fa fa-users mr-2 text-white' : 'fa fa-users mr-2 text-gray-600 group-hover:fill-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}" />
        <div :class="isUrl('vendors') ? 'menu-item font-bold selected' : 'text-gray-500 group-hover:text-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}">Vendedores</div>
      </Link>
    </div>
    <div v-if="role == 'admin' || role == 'financial'" class="mb-4">
      <Link class="group flex items-center py-3" href="/spents">
        <i :class="isUrl('spents') ? 'fa fa-money mr-2 text-white' : 'fa fa-money mr-2 text-gray-600 group-hover:fill-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}" />
        <div :class="isUrl('spents') ? 'menu-item font-bold selected' : 'text-gray-500 group-hover:text-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}">Gastos</div>
      </Link>
    </div>
    <div v-if="role == 'admin' || role == 'financial'" class="mb-4">
      <Link class="group flex items-center py-3" href="/taxes">
        <i :class="isUrl('taxes') ? 'fa fa-file-o mr-2 text-white' : 'fa fa-file mr-2 text-gray-600 group-hover:fill-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}" />
        <div :class="isUrl('taxes') ? 'menu-item font-bold selected' : 'text-gray-500 group-hover:text-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}">Tasa de cambio</div>
      </Link>
    </div>
    <div v-if="role == 'admin' || role == 'financial'" class="mb-4">
      <Link class="group flex items-center py-3" href="/reports">
        <i :class="isUrl('reports') ? 'fa fa-file-o mr-2 text-white' : 'fa fa-file mr-2 text-gray-600 group-hover:fill-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}" />
        <div :class="isUrl('reports') ? 'menu-item font-bold selected' : 'text-gray-500 group-hover:text-white menu-item'" :style="{'--text-color': account.textSidebarColor ?? 'black', '--hover-color': account.textHoverSidebarColor}">Reportes</div>
      </Link>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
    Link,
  },
  props: {
    account: Object,
    role: Object
  },
  methods: {
    back() {
      window.history.back();
    },
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}
</script>
